"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareTile = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NoCardSelected = require("./NoCardSelected");
var _CardSelected = require("./CardSelected");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CompareTile = exports.CompareTile = function CompareTile(_ref) {
  var namespace = _ref.namespace,
    indexpos = _ref.indexpos,
    styles = _ref.styles,
    addCard = _ref.addCard,
    removeCard = _ref.removeCard,
    onLearnMore = _ref.onLearnMore,
    iconColor = _ref.iconColor,
    card = _ref.card,
    addCardText = _ref.addCardText,
    annualFeeLabel = _ref.annualFeeLabel,
    addCardDtm = _ref.addCardDtm,
    linkComponent = _ref.linkComponent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('compare-tile', card ? "".concat(card.shortName, "-tile") : '', styles.compareTile)
  }, card ? /*#__PURE__*/_react["default"].createElement(_CardSelected.CardSelected, {
    styles: styles,
    cardTitle: card.cardTitle,
    cardArtUrl: card.cardArtUrl,
    cardArtAlt: card.cardArtAlt,
    onLearnMore: onLearnMore,
    links: card.links,
    removeCard: removeCard,
    card: card,
    iconColor: iconColor,
    namespace: namespace,
    indexpos: indexpos,
    annualFeeLabel: annualFeeLabel,
    linkComponent: linkComponent
  }) : /*#__PURE__*/_react["default"].createElement(_NoCardSelected.NoCardSelected, {
    styles: styles,
    addCard: addCard,
    iconColor: iconColor,
    addCardText: addCardText,
    namespace: namespace,
    indexpos: indexpos,
    dtm: addCardDtm
  }));
};
CompareTile.defaultProps = {
  card: undefined,
  annualFeeLabel: undefined,
  styles: {},
  iconColor: '#00175A',
  namespace: '',
  indexpos: 0,
  addCardDtm: {},
  linkComponent: undefined,
  onLearnMore: undefined
};
CompareTile.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  addCard: _propTypes["default"].func.isRequired,
  removeCard: _propTypes["default"].func.isRequired,
  onLearnMore: _propTypes["default"].func,
  iconColor: _propTypes["default"].string.isRequired,
  card: _propTypes["default"].shape({
    cardTitle: _propTypes["default"].string,
    cardArtUrl: _propTypes["default"].string,
    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      url: _propTypes["default"].string,
      title: _propTypes["default"].string
    }))
  }),
  addCardText: _propTypes["default"].string.isRequired,
  annualFeeLabel: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  indexpos: _propTypes["default"].number,
  addCardDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  linkComponent: _propTypes["default"].func
};